export const delayHelper = {
  delayPromise,
}

function delayPromise (delayTime) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, delayTime)
  })
}